import { render, staticRenderFns } from "./usher_page_new.vue?vue&type=template&id=efcfd6a6&scoped=true&"
import script from "./usher_page_new.vue?vue&type=script&lang=js&"
export * from "./usher_page_new.vue?vue&type=script&lang=js&"
import style0 from "./usher_page_new.vue?vue&type=style&index=0&id=efcfd6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcfd6a6",
  null
  
)

export default component.exports